export const MOUNTED = 'MOUNTED';
export const FETCH_DATA = 'FETCH_DATA';
export const PUSH = 'PUSH';
export const REPLACE = 'REPLACE';
export const VIEW = 'VIEW';
export const CLICK = 'CLICK';
export const HANDLE_LINK_CLICK = 'HANDLE_LINK_CLICK';
